import React, { Component } from "react";

import "react-toastify/dist/ReactToastify.css";
import "./monthly-invoice.css";

import { getAllSourcingTransactionsRedux } from "../../../../actions/index";

import { connect } from "react-redux";

export class MonthlyExpense extends Component {
  componentDidMount = async () => {
    this.props.getAllSourcingTransactionsRedux(
      this.props.agent,
      this.props.month,
    );
  };

  render() {
    const { transactions } = this.props;
    const { selectedTab } = this.props;

    let sortedTransfers = transactions.sort((a, b) => b.id - a.id);
    if (selectedTab == "rmb") {
      sortedTransfers = sortedTransfers.filter(
        (transfer) => transfer.fundType == "RMB",
      );
    }
    if (selectedTab == "rupee") {
      sortedTransfers = sortedTransfers.filter(
        (transfer) => transfer.fundType == "RUPEES",
      );
    }

    return (
      <div className="col-sm-12">
        <div className="card">
          <div
            className="card-header"
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            <h5>
              <i
                className="icofont-calendar"
                style={{
                  fontSize: "130%",
                  marginRight: "5px",
                  color: "darkblue",
                }}
              ></i>
              {this.props.month}
            </h5>
          </div>

          <div className="card-body">
            <div className="clearfix"></div>
            <div className="consultancy-ledger">
              {sortedTransfers.length > 0 ? (
                sortedTransfers.map((transfer, index) => {
                  const isFund = !transfer.country;
                  const balance =
                    transfer.fundType === "RMB"
                      ? `${parseFloat(transfer.rmbBalance || 0).toFixed(2)} Rmb`
                      : `${parseFloat(transfer.rupeeBalance || 0).toFixed(2)} Rupees`;

                  return (
                    <div className="consultancy-ledger-row" key={index}>
                      <div className="consultancy-ledger-main">
                        <span
                          className={`consultancy-ledger-badge${
                            isFund
                              ? " consultancy-ledger-badge--credit"
                              : " consultancy-ledger-badge--debit"
                          }`}
                        >
                          {isFund ? "Fund" : "Spend"}
                        </span>
                        <div className="consultancy-ledger-info">
                          <div className="consultancy-ledger-title">
                            {isFund
                              ? transfer.subCategory || "Fund added"
                              : transfer.category || "Invoice payment"}
                          </div>
                          <div className="consultancy-ledger-date">
                            {transfer.date}
                          </div>
                        </div>
                      </div>

                      <div className="consultancy-ledger-chips">
                        {isFund ? (
                          <>
                            {transfer.note && (
                              <span className="consultancy-chip">
                                <span className="consultancy-chip-label">
                                  Buy rate
                                </span>
                                {transfer.note.slice(10)}Tk
                              </span>
                            )}
                            {transfer.amount && (
                              <span className="consultancy-chip">
                                <span className="consultancy-chip-label">
                                  Amount
                                </span>
                                {transfer.amount}Tk
                              </span>
                            )}
                          </>
                        ) : (
                          <>
                            {transfer.paidInvoice && (
                              <span className="consultancy-chip">
                                <span className="consultancy-chip-label">
                                  Invoice
                                </span>
                                {transfer.paidInvoice}
                              </span>
                            )}
                            {transfer.buyRate && (
                              <span className="consultancy-chip">
                                <span className="consultancy-chip-label">
                                  Buy rate
                                </span>
                                {transfer.buyRate}Tk
                              </span>
                            )}
                            {transfer.sellRate && (
                              <span className="consultancy-chip">
                                <span className="consultancy-chip-label">
                                  Sell rate
                                </span>
                                {transfer.sellRate}Tk
                              </span>
                            )}
                            {transfer.totalRmb && (
                              <span className="consultancy-chip">
                                <span className="consultancy-chip-label">
                                  Total bill
                                </span>
                                {transfer.totalRmb} {selectedTab}
                              </span>
                            )}
                          </>
                        )}
                      </div>

                      <div className="consultancy-ledger-trailing">
                        <span
                          className={`consultancy-ledger-amount${
                            isFund
                              ? " consultancy-ledger-amount--credit"
                              : " consultancy-ledger-amount--debit"
                          }`}
                        >
                          {isFund ? "+" : "-"}
                          {isFund ? transfer.totalRmb : transfer.amount}{" "}
                          {selectedTab}
                        </span>
                        <div className="consultancy-ledger-balance">
                          <div className="consultancy-ledger-balance-value">
                            {balance}
                          </div>
                          <div className="consultancy-ledger-entryby">
                            {transfer.expenseBy}
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })
              ) : (
                <div className="consultancy-ledger-empty">
                  No transactions for this period.
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    cnfBills: state.cnfs.cnfBills,
    cnfExpenses: state.cnfs.cnfExpenses,
    transactions: state.sourcings.sourcingTransactions,
  };
};

export default connect(mapStateToProps, {
  getAllSourcingTransactionsRedux,
})(MonthlyExpense);
